import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { State } from '../state/state';
import * as fromCard from '../state/selectors';
import { SelectedCard } from '../card.model';

@Injectable()
export class SelectedCardQuery {

  constructor(private store: Store<State>) { }

  get values(): Observable<SelectedCard> {
    return this.store.pipe(
      select(fromCard.getSelectedCard)
    );
  }
}